import { EyeOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Button, Image, Table, Tag, Typography } from "antd";
import { useState } from "react";
import { usePagination } from "@/shared/hooks/usePagination";
import { snapshotService } from "../services/snapshot.service";

const { Title } = Typography;

export function SnapshotsPage() {
	const { page, pageSize, onChange } = usePagination();
	const [previewUrl, setPreviewUrl] = useState<string | null>(null);

	const { data, isLoading } = useQuery({
		queryKey: ["snapshots", { page, per_page: pageSize }],
		queryFn: () => snapshotService.list({ page, per_page: pageSize }),
	});

	const snapshots = data?.data?.snapshots || [];
	const pagination = data?.data?.pagination;
	const baseUrl = import.meta.env.VITE_API_URL;

	const columns = [
		{ title: "ID", dataIndex: "id", width: 60 },
		{
			title: "Rasm", dataIndex: "image", width: 80,
			render: (v: string) => (
				<img src={`${baseUrl}${v}`} alt="" className="w-16 h-12 object-cover rounded cursor-pointer" onClick={() => setPreviewUrl(`${baseUrl}${v}`)} />
			),
		},
		{ title: "To'yxona", key: "hall", render: (_: unknown, r: Record<string, unknown>) => (r.wedding_hall as { name: string } | null)?.name || "—" },
		{ title: "Kamera", key: "camera", render: (_: unknown, r: Record<string, unknown>) => (r.camera as { name: string } | null)?.name || "—" },
		{
			title: "Odam soni", dataIndex: "people_count",
			render: (v: number | null) => v !== null ? <Tag color={v > 20 ? "red" : "blue"}>{v}</Tag> : "—",
		},
		{ title: "AI", dataIndex: "ai_processed", render: (v: boolean) => <Tag color={v ? "green" : "orange"}>{v ? "Ha" : "Yo'q"}</Tag> },
		{ title: "Vaqt", dataIndex: "captured_at" },
	];

	return (
		<div>
			<Title level={3}>Snapshotlar</Title>
			<Table columns={columns} dataSource={snapshots} rowKey="id" loading={isLoading}
				pagination={{ current: pagination?.current_page, pageSize: pagination?.per_page, total: pagination?.total_items, onChange, showSizeChanger: true }} />
			<Image
				style={{ display: "none" }}
				preview={{ visible: !!previewUrl, src: previewUrl || "", onVisibleChange: () => setPreviewUrl(null) }}
			/>
		</div>
	);
}
